import { observer } from 'mobx-react';
import * as React from 'react';
import Head from 'next/head';
import { Store } from '../store/Store';
import { StoreContext } from '../utils';

interface Props {}

@observer
export class PortalHtmlHead extends React.Component<Props> {
  static contextType = StoreContext;
  declare context: Store;
  render() {
    const { portalStore, requestStore } = this.context;

    return (
      <Head>
        <meta charSet="utf-8" />
        <title>{portalStore.metaTitle || 'Schlaukopf'}</title>
        <meta name="description" content="Schlaukopf" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        {/*begin::Fonts */}
        <link rel="stylesheet" href="/fonts/poppins.css" />
        {/*end::Fonts */}
        <link href="/static/dist7/assets/plugins/global/plugins.bundle.css" rel="stylesheet" type="text/css" />
        <link href="/static/dist7/assets/plugins/custom/prismjs/prismjs.bundle.css" rel="stylesheet" type="text/css" />
        <link href="/static/dist7/assets/css/style.bundle.css" rel="stylesheet" type="text/css" />
        {/*end::Global Theme Styles */}
        {/*begin::Layout Skins(used by all pages) */}
        {/*end::Layout Skins */}
        <link rel="shortcut icon" href="/favicon.ico" />

        {(portalStore.metaStylesheets || ([] as string[])).map(src => (
          <link href={src} rel="stylesheet" type="text/css" key={src} />
        ))}
      </Head>
    );
  }
}
